module.exports = __webpack_public_path__ + "img/VetoSans-Italic_1.daeca0b6.svg";